import React, { useEffect, useState } from 'react';
import MarketingLayout from './MarketingLayout';
import { getPublicChannelItems } from '../../services/content';
import { ContentItem } from '../../types/content';
import { sanitizeAndNormalizeRichText } from '../../utils/richText';
import { useDocumentMeta } from '../../hooks/useDocumentMeta';

const GuidePage: React.FC = () => {
  useDocumentMeta({
    title: '系统使用指南',
    description: '安飞供应链WMS系统操作指南，帮助客户和仓库员工快速上手入库、仓储、出库等常见流程。',
  });

  const [rows, setRows] = useState<ContentItem[]>([]);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getPublicChannelItems('user_guide');
        setRows(data.results || []);
      } catch {
        setRows([]);
      }
    };
    load();
  }, []);

  return (
    <MarketingLayout>
      <section className="mx-auto max-w-6xl px-6 py-14">
        <h1 className="text-3xl font-bold text-gray-900">系统使用指南</h1>
        <p className="mt-3 max-w-3xl text-sm leading-7 text-gray-600">
          常见流程与操作建议，可用于快速上手系统。
        </p>
      </section>

      <section className="mx-auto max-w-6xl space-y-3 px-6 pb-20">
        {rows.length ? (
          rows.map((x) => (
            <div key={x.id} className="rounded-xl border border-[#d9eaff] bg-white p-5 shadow-sm">
              <h3 className="text-base font-semibold text-[#2f82e8]">{x.title}</h3>
              <div
                className="content-rich-text mt-2 whitespace-pre-wrap text-sm leading-7 text-gray-600"
                dangerouslySetInnerHTML={{ __html: sanitizeAndNormalizeRichText(x.body || x.summary || '') }}
              />
            </div>
          ))
        ) : (
          <div className="rounded-xl border border-[#d9eaff] bg-white p-5 text-sm text-gray-500 shadow-sm">
            暂无系统使用指南内容
          </div>
        )}
      </section>
    </MarketingLayout>
  );
};

export default GuidePage;

